import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsAssistance from "../generic-nav-bar/NavbarIconsAssistance";
import useFormValidations from "../../app/hooks/useFormValidations";
import { useHydrateViewCatalogRelations } from "../../app/hooks/useHydrateViewCatalogRelations";
import { Link } from "react-router-dom";
import { startLoadingCatalogCiiusAll } from "../../app/actions/catalogCiiuActions";
import { startLoadingContinents } from "../../app/actions/continentActions";
import { startLoadingRegions } from "../../app/actions/regionActions";
import { startLoadingCountries } from "../../app/actions/countryActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import IntegrationViewChrome from "../end-user-search/IntegrationViewChrome";
import { useIntegrationNestedPreview } from "../end-user-search/integrationNestedPreviewContext";
import DetailSectionsLayout from "../end-user-search/DetailSectionsLayout";
import { getSectionHeader } from "../../app/helpers/helperValidationViewPreview";

const PreviewAssistance = () => {
  debugLogPages(':: PreviewAssistance'); 
  const dispatch = useDispatch();
  const { nested, setDetailMode } = useIntegrationNestedPreview();

  const { t } = useTranslation();

  /********Store*******/
  const { assistanceSelected } = useSelector((state) => state.assistance);

  const { listFieldsAssistanceView, listFieldsAssistancePreview } = useSelector((state) => state.moduleConfig);

  /********UseForm*******/
  const { values, setValues } = useFormValidations(
    () => AssistanceCallback(),
    assistanceSelected,
    listFieldsAssistanceView
  );

  const AssistanceCallback = () => {
    
  };

  useHydrateViewCatalogRelations('Assistance', values, setValues);

  useEffect(() => {
    /*JT Load Please */
    dispatch(startLoadingCatalogCiiusAll());

    dispatch(startLoadingContinents());
    dispatch(startLoadingRegions());
    dispatch(startLoadingCountries());

  }, [])

  const { arrayListPrincipal, arrayListSecondary } = listFieldsAssistancePreview;

  const assistanceViewRelations = {
    multimedia: "ModuleFile_To_Assistance",
    problems: "ModuleProblem_To_Assistance"
  };

  const sharedViewProps = {
    values,
    t,
    ProblemTableComponent: null, // Mantiene la tabla comentada/desactivada de manera limpia
    relationKeys: assistanceViewRelations,
    isPreviewMode: true // Filtra mediante show_view_preview
  };

        const principalHeader = getSectionHeader(arrayListPrincipal);
        const secondaryHeader = getSectionHeader(arrayListSecondary);

  const onGoFullVersion = (e) => {
    if (!nested || !setDetailMode) return;
    e.preventDefault();
    setDetailMode('view');
  };

  return (
    <div>
      {!nested && <NavbarIconsAssistance page={"viewText"} />}

      {!nested && (
        <IntegrationViewChrome
          sourceModuleKey="assistance"
          record={assistanceSelected}
        />
      )}

      <div className="d-flex justify-content-center page-title">{t("assistance.preview.title")}</div>
      <hr className="line-hr" />
      <div className="section is-fullheight">
        <div className="container">
          <form>
            <div className="container-fluid">
              <div className="text-center fw-bolder">
                <div className="text-center">
                  {nested ? (
                    <button
                      type="button"
                      className="btn btn-link p-0 fw-bolder"
                      onClick={onGoFullVersion}
                    >
                      {t("assistance.preview.redirect")}
                    </button>
                  ) : (
                    <Link to="/end-user-search/view-assistance">
                      {t("assistance.preview.redirect")}
                    </Link>
                  )}
                </div>
              </div>

              <DetailSectionsLayout
                nested={nested}
                isPreviewMode
                arrayListPrincipal={arrayListPrincipal}
                arrayListSecondary={arrayListSecondary}
                principalHeader={principalHeader}
                secondaryHeader={secondaryHeader}
                sharedViewProps={sharedViewProps}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PreviewAssistance;
